import React from 'react';
import styled from 'styled-components';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    defaults,
} from 'chart.js';
import { Line } from 'react-chartjs-2';



function BarChartCard(props) {
    defaults.font.family = 'IRAN Sans';
    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Legend
    );

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
            },
            title: {
                display: true,
                text: props.chartText,
            },
        },
        maintainAspectRatio:false
    };

    const labels = props.chartData.map((item) => item.transactionPersianDate)// ['شنبه', 'یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه'];

    const data = {
        labels,
        datasets: [
            {
                label: props.chartText,
                data: props.chartData.map((item) => item.transactionAmount),
                borderColor: props.isMonthly?'#db5726':'#45db26',
                backgroundColor: props.isMonthly?'rgba(219, 87, 38, 0.5)':'rgba(87, 219, 38, 0.5)',
            }
        ],
    };
    return (
        <ChartContainer>
            <Line options={options} data={data}/>
        </ChartContainer>
    );
}

const ChartContainer = styled.div`
    background-color:#fff;
    border-radius:1.2rem;
    width:43%;
    height:12.5rem;
    padding:1.8rem;
    text-align:center;
    margin:10px 0;
    @media screen and (min-width: 320px) and (max-width: 1080px){
        height:max-content;
        width: 80% !important;
        margin:auto;
        margin-right:0;
        margin-top:10px;
    }
`;

export default BarChartCard;